<template>
  <svg
    aria-hidden="true"
    tabindex="-1"
    role="presentation"
    class="icon icon-pause"
    viewBox="0 0 32 32"
  >
    <path
      fill="#ffffff"
      d="M27.637,32h-5.818V0h5.818V32L27.637,32z M10.182,32H4.363V0h5.818V32z"
    />
  </svg>
</template>
<script>
export default {};
</script>
